var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.css},[_c('h1',{staticClass:"font-blau leading-none text-68 md-text-8vw xl-text-100 text-center break-all p-2",domProps:{"innerHTML":_vm._s(_vm.row.title)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }